import * as React from 'react';
import ReactDOM from 'react-dom';

import BaseItemView from 'app/src/views/base/BaseItemView';
import { GiftCardList } from 'app/src/views/payments/GiftCardList';

const _Events = {
  CANCEL_BUTTON_CLICKED: 'cancel:button:clicked',
  SELECT_ONE_GIFT_CARD: 'select:one:gift:card',
};

// configure
let View = BaseItemView.extend({
  template: false,
  onRender() {
    ReactDOM.render(<GiftCardList viewData={this.viewData} />, this.el);
  },
  onDestroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  },
  ui: {
    giftCardButton: '.giftCardButton',
    cancelButton: '#selectGiftCardCancel',
  },

  events: {
    'click @ui.giftCardButton': 'onSelectGiftCard',
  },

  triggers: {
    'click @ui.cancelButton': _Events.CANCEL_BUTTON_CLICKED,
  },
});

// Defined
export default class PaymentScanGiftCardView extends View {
  static get Events() {
    return _Events;
  }

  onSelectGiftCard(event) {
    this.trigger(_Events.SELECT_ONE_GIFT_CARD, event.currentTarget.getAttribute('data-code'));
  }
}
